import React from "react"
import { Typography } from "@mui/material"
import { styled } from "@mui/material/styles"

const StyledTypography = styled(Typography)(({ theme }) => ({
  height: "18px",
  fontFamily: "HiraKakuProN-W3",
  fontSize: "12px",
  lineHeight: 1.45,
  letterSpacing: "normal",
  color: "#727272",
}))

const HeaderSubText = (props) => {
  return <StyledTypography noWrap={true}>{props.children}</StyledTypography>
}

export default HeaderSubText
